export const KEY = 'lib_notification'
